import Enumeration from "domain/Enumeration";

const S3DocumentTypeEnum = new Enumeration({
    LIMIT_INCREASE_DOCUMENT: "LIMIT_INCREASE_DOCUMENT",
    REGISTRATION_DOCUMENT: "REGISTRATION_DOCUMENT"
});

export default S3DocumentTypeEnum;